import React, { FC } from "react";

const View: FC<{ children: JSX.Element }>  = ({children}) => {
  return (
    <div className="flex h-[93.5vh] w-full bg-black first:font2 flex-col items-center overflow-y-auto font3 pl-16 pr-16">
        {children}
      <div className="w-full h-[10rem]">
        {/* spacer for scrollbar to take effect */}
      </div>
    </div>
  );
};

export default View;
